export default __webpack_public_path__ + "static/media/Captura de pantalla de 2023-01-18 00-03-09.084410e9.png";